import gsap from 'gsap';
import imagesloaded from 'imagesloaded';
import { trace } from 'rytm-helpers'
import { initASwap } from './aswap'
import { initPopup } from './shared/popup'

// start loading animation
export const startIntroAnimation = () => {
  const box = getIndexLoaderBox();
  if (!box || !box.classList.contains("intro-index-loader")) {
    onIntroAnimationBreak();
  } else {
    introPrepare();
  }
} 
const onIntroAnimationBreak = () => {
  setTimeout(() => {
    initASwap();
  }, 950);
  onIntroAnimationComplete(false);
}
const onIntroAnimationAlmostComplete = () => {
  // init aswap
  initASwap();
}
const onIntroAnimationComplete = (introCompleted = true) => {
  if (introCompleted) {
    document.documentElement.classList.add("intro-completed");
  }
  document.documentElement.classList.remove("index-loading");
  // remove intro scenes from DOM
  removeIntroScenesFromDom();
  // popup...
  setTimeout(() => {
    initPopup();
  }, 600);
}
const removeIntroScenesFromDom = () => {
  introWrapper = document.querySelector(".intro-scenes");
  if (introWrapper) {
    introWrapper.remove();
  }
}
const getIndexLoaderBox = () => {
  return document.getElementById("index-loader");
}


let introWrapper, video, videoRect, imagesWrapper, image1, image2, image3, image4, headline1, headline2;

const introPrepare = () => {
  // get elements
  introWrapper = document.querySelector(".intro-scenes");
  video = document.querySelector(".scene-1 .video-wrapper");
  imagesWrapper = document.querySelector(".scene-1 .scene-images-wrapper");
  image1 = document.querySelector(".scene-1 .image-1");
  image2 = document.querySelector(".scene-1 .image-2");
  image3 = document.querySelector(".scene-1 .image-3");
  image4 = document.querySelector(".scene-1 .image-4");
  headline1 = document.querySelector(".scene-2 .headline-1");
  headline2 = document.querySelector(".scene-3 .headline-2");
  if (!introWrapper || !video || !imagesWrapper || !image1 || !image2 || !image3 || !image4 || !headline1 || !headline2) {
    onIntroAnimationBreak();
    return;
  }
  document.documentElement.classList.add("intro-init")
  // store video rectangle
  videoRect = video.getBoundingClientRect();
  // check if video already loaded
  const videoEl = video.querySelector("video");
  trace("video ready state", videoEl.readyState);
  if (videoEl.readyState >= 3) {
    introScene1PreloadImages();
  } else {
    // video add on load event
    videoEl.addEventListener("loadeddata", introScene1PreloadImages);
  }
}
// wait for images to load
const introScene1PreloadImages = () => {
  imagesloaded(introWrapper, introScenesInit);
}
// set start position of all scenes
const introScenesInit = () => {
  // kill all tweens
  gsap.killTweensOf([video, image1, image2, image3, image4]);
  // calculate video scale 100vw;
  videoRect.scale100vw = window.innerWidth / videoRect.width;
  // calculate video center x / y;
  videoRect.centerX = window.innerWidth / 2 - videoRect.width / 2 - videoRect.left;
  videoRect.centerY = window.innerHeight / 2 - videoRect.height / 2 - videoRect.top;
  // set initial positions
  // video 25 vw + center + outside viewport
  gsap.set(video, {
    scale: videoRect.scale100vw * .25,
    x: videoRect.centerX,
    y: videoRect.centerY - window.innerHeight * .5 - videoRect.height * .5 * videoRect.scale100vw * .25,
  });
  // all images scale 0
  gsap.set([image1, image2, image3, image4], {
    scale: 0,
  });
  // headlines positions
  gsap.set([headline1, headline2], {
    y: window.innerHeight * .5 + 100,
  });
  introScenesActivate();
  introScenesAnimate();
}
// activate all scenes
const introScenesActivate = () => {
  const scenes = document.querySelectorAll(".intro-scenes .scene");
  scenes.forEach(scene => {
    scene.classList.add("active");
  });
}
// get screen orientation landscape vs portrait
const getScreenOrientation = () => {
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
}
// animate sequence
const introScenesAnimate = () => {
  const tl = gsap.timeline({
    onComplete: onIntroAnimationComplete,
  });
  // const calculate video scale to cover 100 height of screen;
  const mobileVidScaleY = window.innerHeight / videoRect.height * .5;
  // video scale depending on screen orientation
  const videoScaleF = getScreenOrientation() == "landscape" ? .8 : mobileVidScaleY;

  // tmp
  // gsap.set(video, {
  //   y: videoRect.centerY,
  //   scale: videoRect.scale100vw * videoScaleF,  
  // });
  // video.closest(".video-portrait-clip").classList.add("mask-on");
  // return false;


  // video move IN & scale up
  tl.to(video, {
    duration: .3,
    y: videoRect.centerY,
    ease: "expo.out",
    onComplete: () => {
      video.closest(".video-portrait-clip").classList.add("mask-on");
    }
  });
  tl.to(video, {
    duration: .7,
    delay: .05,
    scale: videoRect.scale100vw * videoScaleF,
    ease: "power3.inOut"
  });
  // video to oryginal position
  tl.to(video, {
    duration: .8,
    delay: 2,
    scale: 1,
    x: 0,
    y: 0,
    ease: "power3.inOut",
    onComplete: () => {
      video.closest(".video-portrait-clip").classList.remove("mask-on");
    }
  });
  // bring in images 1 & 2
  tl.to([image1, image2], {
    duration: .8,
    scale: 1,
    ease: "power3.inOut"
  }, "-=.8");
  // bring in image 3
  tl.to(image3, {
    duration: .6,
    scale: 1,
    ease: "power3.inOut"
  });
  // bring in image 4
  tl.to(image4, {
    duration: .6,
    scale: 1,
    ease: "power3.inOut"
  }, "-=.1");  
  // video move out
  tl.to(video, {
    duration: .6,
    delay: 1,
    scale: videoRect.scale100vw * .25,
    y: videoRect.centerY - window.innerHeight * .8 - videoRect.height * .5 * videoRect.scale100vw * .25,
    ease: "power2.in"
  });
  // images scale out + alpha out
  tl.to(imagesWrapper, {
    duration: .6,
    y: - window.innerHeight * .2,
    scale: 10,
    ease: "power2.in",
  }, "-=.6");
  tl.to(imagesWrapper, {
    duration: .1,
    opacity: 0,
    ease: "power2.in",
  }, "-=.1");
  // headline 1 move in
  tl.to(headline1, {
    duration: .8,
    y: 0,
    ease: "power3.inOut",
  }, "-=.5");
  // headline 1 move out
  tl.to(headline1, {
    duration: .8,
    delay: 1.7,
    y: - window.innerHeight * .7 - 100,
    ease: "power3.inOut",
  });
  // headline 2 move in
  tl.to(headline2, {
    duration: .8,
    y: 0,
    ease: "power3.inOut",
  }, "-=.8");
  // headline 2 wait
  tl.to(headline2, {
    duration: 1.7,
    y: 0,
    ease: "power3.inOut",
    onComplete: onIntroAnimationAlmostComplete,
  });
  // move curtain up
  tl.to(introWrapper, {
    duration: 1,
    y: - window.innerHeight - 20,
    ease: "power3.inOut",
  });


}
